import axios from "axios";
import config from "./config";

// Determine the current environment from REACT_APP_* (Create React App embeds these at build time)
const getEnvironment = () => {
  const env = process.env.REACT_APP_ENV || 'staging';
  const apiUrl = process.env.REACT_APP_API_URL || 'https://api.amanhmo.com.ng/';

  return {
    uri: apiUrl,
    uri_img: apiUrl,
    name: env,
  };
};

export const { uri, uri_img, name } = getEnvironment();

export const isDev = () =>   name === 'development';

// export const uri = isDev()? 'https://v1.claima.io' : 'https://v1.claima.io';
// export const uri_img = 'https://v1.claima.io';
// export const uri = isDev()? 'https://v1.amanhmo.com/' : 'https://v1.amanhmo.com/';
// export const uri_img = 'https://v1.amanhmo.com/';
// export const worldTimeApi = 'http://worldtimeapi.org/api/ip';

export const headers =  {
  'Version': '1.5.1',
  'Application': 2,
  'Dev': isDev() ? 1 : 0
}

// Function to handle logout on 401
const handleUnauthorized = () => {
  localStorage.removeItem(config.key.user);
  localStorage.removeItem(config.key.token);
  window.location.href = '/login?reason=session_expired';
};

const Axios = axios.create({baseURL: uri, headers });

// Add response interceptor to handle 401/403 responses
Axios.interceptors.response.use(
  (response) => {
    // Check if response status is 401
    if (response.status === 401) {
      handleUnauthorized();
      return Promise.reject(new Error('Unauthorized'));
    }
    return response;
  },
  async (error) => {
    // Handle 401 errors from the server
    if (error.response && error.response.status === 401) {
      handleUnauthorized();
      return Promise.reject(error);
    }
    
    // Handle 403 errors - dispatch event to refresh profile in case permissions changed
    if (error.response && error.response.status === 403) {
      // Dispatch event to trigger profile refresh (handled by useAuth)
      window.dispatchEvent(new CustomEvent('refreshProfileOn403'));
    }
    
    return Promise.reject(error);
  }
);

export default Axios;